<template>
  <div id="header" :class="styleFunc ? 'home-header' : 'header'">
    <div class="content">
      <img
        v-if="styleFunc"
        @click="$router.push('/')"
        class="logo"
        src="../../static/img/logo.png"
        alt=""
      />
      <img
        v-else
        @click="$router.push('/')"
        class="logo"
        src="http://album.usho.cn/www/upload/53d71b1c387b822bd85eb06572181d17.png"
        alt=""
      />
      <!-- http://album.usho.cn/www/upload/53d71b1c387b822bd85eb06572181d17.png?imageView2/1/q/40 -->
      <!-- :class="{ 'is-home': isHome && !scroll }" -->
      <div>
        <div
          class="menu"
          v-for="(menu, index) in menus"
          :key="index"
          :class="{ 'active-menu': isActive(menu.path) }"
        >
          <div
            :class="styleFunc ? 'menu-text' : 'menu-title'"
            @click="$router.push(menu.path)"
          >
            {{ menu.name }}
          </div>
          <div class="line"></div>
        </div>
      </div>
      <div class="option">
        <div
          class="login"
          :class="{ 'is-home': isHome && !scroll }"
          @click="goPW"
        >
          登录
        </div>
        <div
          class="register"
          :class="{ 'register-is-home': isHome && !scroll }"
          @click="dialogClick('留言信息')"
        >
          免费使用
        </div>
      </div>
    </div>
     <vServicechat ref="child" v-if="showdialog" />
  </div>
</template>
<script>
import vServicechat from "@/components/v-servicechat";
export default {
  components: {
    vServicechat,
  },
  data() {
    return {
      // { name: "价格", path: "/price" },
      // { name: "ENGLISH", path: "/english" },
      menus: [
        { name: "首页", path: "/" },
        { name: "产品", path: "/product" },
        { name: "新媒体", path: "/media" },
        { name: "伙伴案例", path: "/partner" },
        { name: "社汇新闻", path: "/news" },
        { name: "关于友笑", path: "/about" },
      ],
      scroll: false,
      showdialog:false,
    };
  },
  computed: {
    isActive() {
      return (path) =>
        this.$route.path == path ||
        (path == "/about" && this.$route.path.indexOf("/about") >= 0) || (path == "/news" && this.$route.path.indexOf("/news") >= 0) ;
        
    },
    isHome() {
      return this.$route.path == "/";
    },
    styleFunc() {
      return this.isHome && !this.scroll;
    },
  },
  mounted() {
    if (this.$route.path == "/") {
      window.addEventListener(
        "scroll",
        () => {
          let scrollTop =
            document.body.scrollTop || document.documentElement.scrollTop;
          if (scrollTop > 60) {
            this.scroll = true;
          } else {
            this.scroll = false;
          }
        },
        true
      );
    }
  },
  methods: {
    goPW() {
      window.open("https://admin.sosho.cn/#/personal");
    },
    dialogClick(title){
      this.showdialog = true;
      this.$nextTick(() => {
        this.$refs.child.xcxClick(title);
      })
    },
  },
};
</script>

<style scoped>
#header {
  width: 100%;
  height: 96px;
  position: absolute;
  top: 0;
  /* background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0.1) 100%
  ); */
  /* box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.25); */
}
.header {
  background: #fff;
  /* background-color: #ffffff; */
  /* box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.04); */
}
.content {
  width: 100%;
  height: 96px;
  /* margin: 0 auto; */
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.logo {
  width: 139px;
  height: 36px;
  /* margin-top: 14px; */
  float: left;
  /* margin-right: 80px; */
  cursor: pointer;
}
.menu {
  float: left;
  height: 100%;
  padding-top: 4px;
  text-align: center;
  box-sizing: border-box;
  position: relative;
}
.menu-text {
  font-size: 16px;

  font-weight: 400;
  /* color: rgba(0, 0, 0, 0.85); */
  color: #ffffff;
  padding: 0 20px;
  cursor: pointer;
}
.menu-title {
  font-size: 16px;

  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  padding: 0 20px;
  cursor: pointer;
}
.active-menu .menu-text {
  font-weight: 500;
}
.active-menu .line {
  width: 100%;
  position: absolute;
  height: 3px;
  background: #31cec2;
  border-radius: 2px;
  bottom: -35px;
}
.option {
  /* margin-top: 10px;
  float: right; */
}
.login {
  display: inline-block;
  height: 24px;
  font-size: 16px;

  font-weight: 600;
  color: #31cec2;
  line-height: 24px;
  margin-right: 24px;
  cursor: pointer;
}

.is-home {
  color: #ffffff;
}

.register {
  display: inline-block;
  width: 112px;
  height: 44px;
  background: #31cec2;
  border-radius: 8px;
  font-size: 16px;

  font-weight: 500;
  color: #ffffff;
  text-align: center;
  line-height: 44px;
  cursor: pointer;
}
.register:hover {
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);
}
.register-is-home {
  color: #31cec2;
  background-color: #ffffff;
}
.home-header {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.25);
}
</style>



// WEBPACK FOOTER //
// src/components/v-header.vue